export default "./images/survio-2C5GM-assets-ordering.png";